<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// グローバルスタイルのみ
</script>

<style>
/* CSS変数（カラーテーマ） */
:root {
  --color-primary: #00ffd4; /* ボタン */
  --color-text: #333481; /* 文字色 */
  --color-accent: #00a1e9; /* アクセント */
  --color-warning: #e61874; /* 注意書き */
  --color-background: #f5f5f5;
  --color-white: #ffffff;
  --color-border: #e0e0e0;
  --color-success: #4caf50;
  --color-bonus-bg: #e0f7ff; /* 特典背景（薄い水色） */
  --color-bonus-border: #80d8ff; /* 特典ボーダー */
}

/* リセットCSS */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* ルート設定 */
#app {
  font-family: "Helvetica Neue", Arial, "Hiragino Kaku Gothic ProN",
    "Hiragino Sans", Meiryo, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color-text);
  background-color: var(--color-background);
  min-height: 100vh;
}

/* 基本フォントサイズ */
body {
  font-size: 14px;
  line-height: 1.6;
}

/* ボタン基本スタイル */
button {
  cursor: pointer;
  font-family: inherit;
  border: none;
  outline: none;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* リンク基本スタイル */
a {
  color: var(--color-accent);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

/* 入力フィールド基本スタイル */
input,
textarea {
  font-family: inherit;
  font-size: inherit;
}

/* スクロールバーのスタイル（Webkit） */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
